import { useCallback } from 'react';

import { client, useFormErrorHandler } from 'core/http';
import { VehicleSchema } from 'core/schemas/vehicle';
import { Vehicle } from 'core/types/vehicle';

export default function useVehicleCreates() {
  const handleFormErrors = useFormErrorHandler();

  return useCallback((payload: VehicleSchema) => {
    return client()
      .post<Vehicle>(`vehicles`, payload)
      .then(response => response.data)
      .catch(handleFormErrors);
  }, [handleFormErrors]);
}
